import {
  USER_INFO_RESET_ERROR,

  USER_INFO_LOAD_REQUESTED,
  USER_INFO_LOAD_SUCCEEDED,
  USER_INFO_LOAD_FAILED,

  USER_AMEND_LOAD_REQUESTED,
  USER_AMEND_LOAD_SUCCEEDED,
  USER_AMEND_LOAD_FAILED,

  USER_CREATE_LOAD_REQUESTED,
  USER_CREATE_LOAD_SUCCEEDED,
  USER_CREATE_LOAD_FAILED,

  USER_AUTHENTICATE_LOAD_FAILED,
} from '../actions/userInfo';

const initialState = {
  data: null,
  error: null,
  fetching: false,
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case USER_INFO_RESET_ERROR:
      return { ...state, error: null };
    case USER_INFO_LOAD_REQUESTED:
    case USER_AMEND_LOAD_REQUESTED:
    case USER_CREATE_LOAD_REQUESTED:
      return { ...state, fetching: true };
    case USER_INFO_LOAD_SUCCEEDED:
    case USER_AMEND_LOAD_SUCCEEDED:
    case USER_CREATE_LOAD_SUCCEEDED:
      return {
        ...state, data: payload, error: null, fetching: false,
      };
    case USER_INFO_LOAD_FAILED:
    case USER_AMEND_LOAD_FAILED:
    case USER_CREATE_LOAD_FAILED:
      return {
        ...state, data: null, error: payload, fetching: false,
      };
    case USER_AUTHENTICATE_LOAD_FAILED:
      return { ...state, fetching: false };
    default:
      return state;
  }
}
